import $ from 'jquery';

$(() => {
  const $togglePassword = $('.toggle-password');

  $togglePassword.on('click', function (e) {
    const $password = $(this).prev('#user_pass, #user_pass_confirm');
    const type = $password.attr('type') === 'password' ? 'text' : 'password';

    // toggle input type for visibility
    $password.attr('type', type);

    // toggle the eye slash icon
    this.classList.toggle('fa-eye-slash');
  });
});
